import watchAddContact from './addContact';
import watchSetContact from './setContact';

const watchAddExteralContact = [watchAddContact, watchSetContact];

export default watchAddExteralContact;
